import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectWidgetMultipleChoiceQuestionsDomain = (state) =>
  state.get("widgetMultipleChoiceQuestionsV2", initialState)

export const makeSelectIsLoading = () =>
  createSelector(selectWidgetMultipleChoiceQuestionsDomain, (state) =>
    state.get("isLoading")
  )

export const makeSelectListMultipleChoiceQuestions = () =>
  createSelector(selectWidgetMultipleChoiceQuestionsDomain, (state) =>
    state.get("listMultipleChoiceQuestions")
  )

const makeSelectWidgetMultipleChoiceQuestions = () =>
  createSelector(selectWidgetMultipleChoiceQuestionsDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetMultipleChoiceQuestions
export { selectWidgetMultipleChoiceQuestionsDomain }
